import { HTMLAttributes } from 'react';
import styled, { css } from 'styled-components';
import { globalTheme } from '@cld/component-theme';

export const SELECTABLE_BORDER_WIDTH = 1;

export interface SelectableProps extends HTMLAttributes<HTMLDivElement> {
  isSelected: boolean,
}

export const Selectable = styled.div<SelectableProps>`
  border-radius: ${globalTheme.radius.lg};
  overflow: hidden;
  cursor: pointer;
  border: ${SELECTABLE_BORDER_WIDTH}px solid transparent;
  background: ${globalTheme.palette.secondary};
  object-fit: contain;

  ${(props) => props.isSelected && css`
    border: ${SELECTABLE_BORDER_WIDTH}px solid ${globalTheme.palette.primary};
  `}
`;
